// extracted by mini-css-extract-plugin
export default {"cls1":"Bp026vpyeVBSJxh6zXdY","cls2":"NtqyRC0uli8scY34tVER Bp026vpyeVBSJxh6zXdY"};